import { render } from "./TotalShareHoldersEquity.vue?vue&type=template&id=4912d73b&scoped=true"
import script from "./TotalShareHoldersEquity.vue?vue&type=script&lang=js"
export * from "./TotalShareHoldersEquity.vue?vue&type=script&lang=js"

import "./TotalShareHoldersEquity.vue?vue&type=style&index=0&id=4912d73b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4912d73b"]])

export default __exports__